<template>
  <div>
    <template v-for="field in fields">
      <RangeInput v-if="field.type == 'range-input'" :fields="field" :key="field.name" />
      <ValueHelpWrapper
        v-else-if="field.type == 'value-help-v2'"
        :key="field.name"
        :field="field"
        :value="formValues[field.name]"
        :fullObject="fullObjects[field.name] || []"
        @input="$emit('update:formValues', { key: field.name, value: $event })"
        @update:fullObject="$emit('update:fullObjects', { key: field.name, value: $event })"
      />
      <FormulateInput 
        v-else-if="field.name === 'delivered_on'" 
        v-bind="field"
        @pick="pickDate($event)"
        @close="closePicker($event)"
        :key="field.name"
      />
      <FormulateInput v-else v-bind="field" :key="field.name" />
    </template>
  </div>
</template>

<script>
import RangeInput from './wrapper/RangeInput'
import ValueHelpWrapper from './wrapper/ValueHelpWrapper'
import { tableFilterFields } from './lib/tableFilterFields'
import moment from 'moment'

export default {
  components: {
    RangeInput,
    ValueHelpWrapper,
  },
  mixins: [tableFilterFields],
  props: {
    formValues: {},
    fullObjects: {},
  },
  emits: ['update:formValues', 'update:fullObjects'],
  data() {
    return {
      pastDate: moment().subtract(1, 'years'),
      futureEnd: moment().add(1, 'years'),
    }
  },
  computed: {
    fields() {
      return this.tableFilterFields.filter(field => field.isShow)
    }
  },
  methods: {
    pickDate(date) {
      let maxDate = 31
      this.pastDate = new Date(date.getTime() - 24 * maxDate * 3600 * 1000)
      if (new Date(date.getTime() + 24 * 0 * 3600 * 1000) == new Date()) {
        this.futureEnd = new Date(date.getTime() + 24 * 0 * 3600 * 1000)
      } else {
        this.futureEnd = new Date(date.getTime() + 24 * maxDate * 3600 * 1000)
      }
    },
    closePicker() {
      this.pastDate = moment().subtract(1, 'years')
      this.futureEnd = moment().add(1, 'years')
    },
  }
}
</script>
